import React from 'react';
import SectionNumberField from "../product_elements/SectionNumberField";
import {toggleElementShowingHidden} from "../../store/configuratorStateSlice";
import ElementReorderButtons from "../product_elements/ElementReorderButtons";
import {removeElement} from "../../store/product/productElementsSlice";

/**
 * Displays a loader matching the layout of an element
 * @param props
 * @returns {null}
 * @constructor
 */
const ElementLoader = (props) => {

    const styles = {
        top: {
            width: '100%',
            height: '40px',
            marginBottom: '10px',
            marginTop: '10px'
        },
        bottom: {
            width: 'calc(100% - 14px)',
            height: '80px',
            margin: '0 auto 10px'

        }
    }
    return (
        <>
            <div className="configurator-step">
                <div className={'loading-gradient'} style={styles.top}></div>
                <div className='row'>
                    <div className={'loading-gradient'} style={styles.bottom}></div>
                </div>
            </div>
        </>
    )
}

export default ElementLoader;